import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { setFilterSliceInitState } from 'utils/redux/reducer/filter-slice';

export const useCustomNavigate = () => {
    const dispatch = useDispatch();
    const Navigate = useNavigate();
    return (path: string, ...options: any) => {
        dispatch(setFilterSliceInitState());
        Navigate(path, ...options);
    }
}

